// @flow

import _ from 'lodash';
import { connect } from 'react-redux';

import { fetchActiveApps } from 'client/actions/ifpApps';
import { postCrossSell } from 'client/actions/ifpCrossSell';

import { getCartPropsFromState } from 'routes/cart/util';
import CartCrossSellSection from 'routes/cart/components/crossSell/CartCrossSellSection';

const mapStateToProps: Object = (state) => {
  const { contentfulData } = state;
  const crossSellTranslations = _.get(
    contentfulData,
    'translations.cart.crossSellTranslations',
    {},
  );
  const { cartAppTypes, activeAppTypes, healthApp, dentalApp, visionApp } = getCartPropsFromState(
    state,
  );

  return {
    crossSellTranslations,
    dentalApp,
    healthApp,
    visionApp,
    excludeTypes: _.uniq([...cartAppTypes, ...activeAppTypes]),
  };
};

export default connect(mapStateToProps, { fetchActiveApps, postCrossSell })(CartCrossSellSection);
